<script lang="ts">
  import Icon from "@shared/svelte/Components/Icon.svelte";

  export let title: string = "";
  export let hideTitleOnMobile = false;
  export let isSevenFiftyUser: boolean = false;
  export let displayLogInOption = false;
  export let displayLogOutOption = false;

  const proviAndSevenFifyLogoImagePath =
    window?.["C"]?.IMAGE_PATHS?.["provi_and_seven_fifty_logo.png"];
</script>

<style>
  header {
    z-index: 1000;
  }
  .margin-left-auto {
    margin-left: auto;
  }
</style>

<header data-grid-area="header">
  <div class="fizz-flex-row">
    <h1 class="fizz-heading-1">
      {#if isSevenFiftyUser}
        <img src={proviAndSevenFifyLogoImagePath} alt="logo" style="height: 30px;" />
      {:else}
        <Icon type="ProviLogo" height="30" width="100" fill="#002B48" />
      {/if}
    </h1>
    {#if title}
      <p
        class="fizz-text-subdued fizz-text-small fizz-nowrap"
        class:fizz-hide-on-small={hideTitleOnMobile}
      >
        {title}
      </p>
    {/if}
    {#if displayLogInOption}
      <div class="margin-left-auto">
        <p class="fizz-hide-on-small">
          Already have an account?
          <!-- svelte-ignore a11y-invalid-attribute -->
          <a href="#" on:click={() => (window.location.href = "/users/sign_in")}>Log in</a>
        </p>
        <p class="fizz-hide-on-large">
          <!-- svelte-ignore a11y-invalid-attribute -->
          <a href="#" on:click={() => (window.location.href = "/users/sign_in")}>Log in</a>
        </p>
      </div>
    {/if}
    {#if displayLogOutOption && !displayLogInOption}
      <div class="margin-left-auto">
        <!-- svelte-ignore a11y-invalid-attribute -->
        <a href="/users/fully_log_out" on:click={() => (window.location.href = "/users/fully_log_out")}
          >Log out</a
        >
      </div>
    {/if}
  </div>
  <slot />
</header>
